export { Config, CONFIG } from './config.module';
